module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/desktop_xl-051ffda813357d1ef4edd827be4019e5.jpg";